export default {
  methods: {
    cacheQuery() {
      this.pushQuery(this.$route, this.cacheData);
    },
  },
};
